import React from 'react'
import Storebar from '../components/Storebar'
import Mainlayout from '../layout/Mainlayout'


export default function Sportitems() {
  return (
    <Mainlayout>
        <div className='bg-dwam'>
           <Storebar/>
        </div>
    </Mainlayout>
  )
}

